<template>
  <CreatePlatform />
</template>

<script setup lang="ts">
import CreatePlatform from '@/features/admin/platform-setup/components/create-platform.vue'
</script>
